module.exports = __webpack_public_path__ + "static/media/screenshot.59200ee9.svg";